interface Props extends React.ComponentProps<"img"> {
	src: string
	alt: string
}

export const RemoteImage = (props: Props) => {
	return <img loading="lazy" decoding="async" {...props} />
}
